module.exports = __webpack_public_path__ + "img/w3_package_thin_dark.3a970bbc.png";